import { Component } from '@angular/core';

@Component({
  selector: 'app-encounter',
  imports: [],
  templateUrl: './encounter.component.html',
  styleUrl: './encounter.component.scss'
})
export class EncounterComponent {

}
